<div class="bg-wrapper pt-2">
    <header class="mb-2 container">
        <div>
            <a href="#" class="brand"
                ><img src="../assets/images/jsw-logo.png" alt="jsw-logo"
            /></a>
        </div>
    </header>

    <main class="container justify-content-center py-5">
        <div class="row">
            <div class="col-md-5 offset-md-4">
                <div class="language-pane">
                    <h3 class="mb-4">Select Language</h3>
                    <p class="mb-4">Choose your prefered language</p>

                    <div class="language">
                        <ul>
                            <li class="mb-1 active">English</li>
                            <li class="mb-1">Kannada</li>
                            <li class="mb-1">Marathi</li>
                            <li class="mb-1">Tamil</li>
                        </ul>
                    </div>

                    <button
                        [routerLink]="['/vendor-master-data']"
                        type="submit"
                        class="btn btn-primary my-3"
                    >
                        Select Language
                    </button>
                </div>
            </div>
        </div>
    </main>

    <footer class="mt-auto d-flex justify-content-center">
        <p>
            Powered by
            <a href="javascript:void(0)" class="brand-payex"
                ><img src="../assets/images/payex-logo.png" alt="PayExLogo"
            /></a>
        </p>
    </footer>
</div>
